interface GiftIconProps {
  className?: string;
}

const GiftIcon = ({ className }: GiftIconProps) => (
  <svg
    viewBox="-10 -6 160 126"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={{ overflow: "visible" }}
    overflow="visible"
    aria-hidden="true"
    role="img"
  >
    <style>
      {`
        @keyframes sparkle {
          0%, 100% { opacity: 0; transform: scale(0.5); }
          50% { opacity: 1; transform: scale(1); }
        }
        .sparkle-1, .sparkle-2, .sparkle-3, .sparkle-4,
        .sparkle-5, .sparkle-6, .sparkle-7 {
          transform-box: fill-box;
          transform-origin: center;
        }
        .sparkle-1 { animation: sparkle 2s ease-in-out infinite; }
        .sparkle-2 { animation: sparkle 2s ease-in-out 0.4s infinite; }
        .sparkle-3 { animation: sparkle 2s ease-in-out 0.8s infinite; }
        .sparkle-4 { animation: sparkle 2s ease-in-out 1.2s infinite; }
        .sparkle-5 { animation: sparkle 2s ease-in-out 1.6s infinite; }
        .sparkle-6 { animation: sparkle 2s ease-in-out 0.6s infinite; }
        .sparkle-7 { animation: sparkle 2s ease-in-out 1.0s infinite; }
      `}
    </style>

    {/* Heart balloon — top left, pink */}
    <path
      d="M22,28 C22,20 14,14 10,20 C6,26 14,36 22,42 C30,36 38,26 34,20 C30,14 22,20 22,28Z"
      fill="#FF69B4"
    />

    {/* Heart balloon — top center, light pink */}
    <path
      d="M62,16 C62,8 54,2 50,8 C46,14 54,24 62,30 C70,24 78,14 74,8 C70,2 62,8 62,16Z"
      fill="#FFB6C1"
    />

    {/* Heart balloon — top right, rose */}
    <path
      d="M105,22 C105,14 97,8 93,14 C89,20 97,30 105,36 C113,30 121,20 117,14 C113,8 105,14 105,22Z"
      fill="#E8485C"
    />

    {/* Heart balloon — far left, deep pink */}
    <path
      d="M8,58 C8,52 2,48 -1,52 C-4,56 2,62 8,66 C14,62 20,56 17,52 C14,48 8,52 8,58Z"
      fill="#FF1493"
      opacity="0.85"
    />

    {/* Heart balloon — far right, salmon */}
    <path
      d="M132,50 C132,44 126,40 123,44 C120,48 126,54 132,58 C138,54 144,48 141,44 C138,40 132,44 132,50Z"
      fill="#FA8072"
      opacity="0.85"
    />

    {/* Heart balloon — small, upper-left area */}
    <path
      d="M38,10 C38,6 34,3 32,6 C30,9 34,13 38,16 C42,13 46,9 44,6 C42,3 38,6 38,10Z"
      fill="#FFB6C1"
      opacity="0.7"
    />

    {/* Heart balloon — small, upper-right area */}
    <path
      d="M90,6 C90,2 86,-1 84,2 C82,5 86,9 90,12 C94,9 98,5 96,2 C94,-1 90,2 90,6Z"
      fill="#FF69B4"
      opacity="0.7"
    />

    {/* Heart-shaped gift box (chocolate box) */}
    <defs>
      <clipPath id="heartClip">
        <path d="M70,110 C70,110 30,88 30,65 C30,52 40,45 50,45 C58,45 64,50 70,58 C76,50 82,45 90,45 C100,45 110,52 110,65 C110,88 70,110 70,110Z" />
      </clipPath>
    </defs>

    {/* Heart shape — red box body */}
    <path
      d="M70,110 C70,110 30,88 30,65 C30,52 40,45 50,45 C58,45 64,50 70,58 C76,50 82,45 90,45 C100,45 110,52 110,65 C110,88 70,110 70,110Z"
      fill="#B40800"
    />
    {/* Heart shape — darker bottom for depth */}
    <path
      d="M70,110 C70,110 30,88 30,72 C45,88 60,95 70,100 C80,95 95,88 110,72 C110,88 70,110 70,110Z"
      fill="#8C0600"
    />

    {/* Ribbon — vertical stripe, clipped to heart */}
    <g clipPath="url(#heartClip)">
      <rect x="65" y="45" width="10" height="65" fill="#DAA520" />
      <rect x="68" y="45" width="3" height="65" fill="#F0C850" opacity="0.5" />

      {/* Ribbon — horizontal stripe */}
      <rect x="25" y="65" width="90" height="8" fill="#DAA520" />
      <rect x="25" y="67" width="90" height="3" fill="#F0C850" opacity="0.5" />
    </g>

    {/* Bow — left loop */}
    <ellipse
      cx="59"
      cy="60"
      rx="10"
      ry="7"
      fill="#DAA520"
      transform="rotate(-20 59 60)"
    />
    <ellipse
      cx="59.5"
      cy="60"
      rx="6"
      ry="4"
      fill="#B40800"
      transform="rotate(-20 59.5 60)"
    />

    {/* Bow — right loop */}
    <ellipse
      cx="81"
      cy="60"
      rx="10"
      ry="7"
      fill="#DAA520"
      transform="rotate(20 81 60)"
    />
    <ellipse
      cx="80.5"
      cy="60"
      rx="6"
      ry="4"
      fill="#B40800"
      transform="rotate(20 80.5 60)"
    />

    {/* Bow — center knot */}
    <ellipse cx="70" cy="63" rx="5" ry="4" fill="#DAA520" />
    <ellipse cx="70" cy="63" rx="2.5" ry="2.5" fill="#F0C850" opacity="0.6" />

    {/* Bow — left tail */}
    <path d="M65,63 Q55,53 50,46 Q52,50 58,55 Q60,58 65,63Z" fill="#DAA520" />
    {/* Bow — right tail */}
    <path d="M75,63 Q85,53 90,46 Q88,50 82,55 Q80,58 75,63Z" fill="#DAA520" />

    {/* Heart balloon — bottom left, small */}
    <path
      d="M18,90 C18,85 13,82 11,85 C9,88 13,92 18,96 C23,92 27,88 25,85 C23,82 18,85 18,90Z"
      fill="#FF69B4"
      opacity="0.6"
    />

    {/* Heart balloon — bottom right, small */}
    <path
      d="M125,85 C125,80 120,77 118,80 C116,83 120,87 125,91 C130,87 134,83 132,80 C130,77 125,80 125,85Z"
      fill="#FFB6C1"
      opacity="0.6"
    />

    {/* Sparkles — 4-pointed stars scattered around the icon */}
    {/* Sparkle near top-left balloon */}
    <g className="sparkle-1" transform="translate(2,18)">
      <path d="M0,-4 L1,-1 L4,0 L1,1 L0,4 L-1,1 L-4,0 L-1,-1Z" fill="#FFD700" />
    </g>

    {/* Sparkle near top-center balloon */}
    <g className="sparkle-2" transform="translate(75,8)">
      <path
        d="M0,-3 L0.8,-0.8 L3,0 L0.8,0.8 L0,3 L-0.8,0.8 L-3,0 L-0.8,-0.8Z"
        fill="#FFF8DC"
      />
    </g>

    {/* Sparkle near top-right balloon */}
    <g className="sparkle-3" transform="translate(120,12)">
      <path
        d="M0,-3.5 L0.9,-0.9 L3.5,0 L0.9,0.9 L0,3.5 L-0.9,0.9 L-3.5,0 L-0.9,-0.9Z"
        fill="#FFD700"
      />
    </g>

    {/* Sparkle on the gift box left */}
    <g className="sparkle-4" transform="translate(38,72)">
      <path
        d="M0,-3 L0.8,-0.8 L3,0 L0.8,0.8 L0,3 L-0.8,0.8 L-3,0 L-0.8,-0.8Z"
        fill="#FFFACD"
      />
    </g>

    {/* Sparkle on the gift box right */}
    <g className="sparkle-5" transform="translate(100,72)">
      <path
        d="M0,-3 L0.8,-0.8 L3,0 L0.8,0.8 L0,3 L-0.8,0.8 L-3,0 L-0.8,-0.8Z"
        fill="#FFD700"
      />
    </g>

    {/* Sparkle near bow */}
    <g className="sparkle-6" transform="translate(70,50)">
      <path
        d="M0,-2.5 L0.7,-0.7 L2.5,0 L0.7,0.7 L0,2.5 L-0.7,0.7 L-2.5,0 L-0.7,-0.7Z"
        fill="#FFF8DC"
      />
    </g>

    {/* Sparkle floating right side */}
    <g className="sparkle-7" transform="translate(128,38)">
      <path
        d="M0,-2.5 L0.7,-0.7 L2.5,0 L0.7,0.7 L0,2.5 L-0.7,0.7 L-2.5,0 L-0.7,-0.7Z"
        fill="#FFD700"
      />
    </g>
  </svg>
);

export default GiftIcon;
